module.exports = __webpack_public_path__ + "img/118.6.81a70ba6.png";